export default __webpack_public_path__ + "static/pull_station_b.2e3c008bbf3781adef93c5b0b2556294.svg";